import { render, staticRenderFns } from "./ticketDetailMobile.vue?vue&type=template&id=776c6769&scoped=true"
import script from "./ticketDetailMobile.vue?vue&type=script&lang=js"
export * from "./ticketDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./ticketDetailMobile.vue?vue&type=style&index=0&id=776c6769&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776c6769",
  null
  
)

export default component.exports